module.exports = __webpack_public_path__ + "media/metal_spin_slowdown.f4b4509a.wav";